import styled from 'styled-components';
import { badgeBackgroundColor } from 'styles/Colors';

export const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0 16px 16px;
  width: 100%;
`;

export const ResumeGameTile = styled.div`
  font-family: Oswald;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 25.2px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const TeamsAndExternalId = styled.div`
  color: #e0e0e0;
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
`;

export const StyledHomeMenuCard = styled.div`
  color: #f5f5f5;
  padding: 16px 24px;
  background-color: #222;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.95);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
`;

export const ResumeGameControls = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
`;

export const ResumeGameText = styled.div`
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`;

export const TeamName = styled.span`
  font-weight: bold;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DualSystemBadge = styled.div<{ disabled?: boolean }>`
  background-color: ${(props) => (props.disabled ? '#7B7B7B' : badgeBackgroundColor)};
  border: 1px solid ${(props) => (props.disabled ? '#7B7B7B' : badgeBackgroundColor)};
  border-radius: 32px;
  padding: 0px 8px;
  font-size: 12px;
  color: #fff;
  width: fit-content;
`;
